'use client';

import { useQuery } from '@tanstack/react-query';
import { useWallet } from './use-wallet';

export type LPPlatform = 'aerodrome' | 'uniswap-v3' | 'uniswap-v4';

export interface LPPosition {
  platform: LPPlatform;
  nftAddress: string;
  tokenId: number;
  token0: { address: string; symbol: string; icon: string | null };
  token1: { address: string; symbol: string; icon: string | null };
  liquidity: string;
  tickLower: number;
  tickUpper: number;
  liquidityUsd: number | null;
  explorerUrl: string;
}

async function fetchLPPositions(address: string): Promise<LPPosition[]> {
  const res = await fetch(`/api/lp-positions/${address}`);
  if (!res.ok) throw new Error('Failed to fetch LP positions');
  return res.json();
}

export function useLPPositions() {
  const { isConnected, address } = useWallet();

  const {
    data: positions = [],
    isLoading,
    error,
    refetch,
  } = useQuery({
    queryKey: ['lp-positions', address?.toLowerCase() ?? null],
    queryFn: () => fetchLPPositions(address!),
    enabled: isConnected && !!address,
    staleTime: 30_000,
    refetchInterval: 60_000,
  });

  return { positions, isLoading, error, refetch };
}
